import type { ReactNode } from "react";
import { ExternalLink } from "lucide-react";
import { cn } from "@/utils/cn";

export function ExternalLinkButton({
  href,
  children,
  variant = "primary",
  className,
}: {
  href: string;
  children: ReactNode;
  variant?: "primary" | "secondary";
  className?: string;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={cn(
        "inline-flex w-full items-center justify-center gap-2 rounded-[var(--radius-sm)] px-3.5 py-2.5 text-[0.8125rem] font-semibold leading-tight",
        variant === "primary"
          ? "bg-[var(--accent)] text-white shadow-sm"
          : "bg-[var(--text)] text-white shadow-sm",
        className,
      )}
    >
      {children}
      <ExternalLink className="h-3.5 w-3.5 shrink-0 opacity-90" aria-hidden />
    </a>
  );
}
